import React from "react";
import { Modal } from "react-bootstrap";

import origin_1 from "../../static/images/insurance/anonymous/origin_car1.png";
import origin_3 from "../../static/images/insurance/anonymous/origin_car3.png";
import regDay from "../../static/images/insurance/anonymous/tutorial1.png";
import regYear from "../../static/images/insurance/anonymous/tutorial2.png";

export const TooltipBox = ({ name, title, isShow, hide }) => {
	let content;

	if (name === "CarOrigin") {
		content = (
			<>
				<p>
					Xem thông tin tại <strong>Nước sản xuất </strong>trên <strong>Giấy đăng kiểm</strong>
				</p>
				<img loading="lazy" src={origin_3} />
			</>
		);
	} else if (name === "RegDay") {
		content = (
			<>
				<p>Xem thông tin tại góc trái bên dưới cavet xe.</p>
				<img loading="lazy" src={regDay} />
			</>
		);
	} else {
		content = (
			<>
				<p>
					Xem thông tin tại mục <strong>Nước sản xuất </strong>trên <strong>Giấy đăng kiểm</strong>
				</p>
				<img loading="lazy" src={origin_3} />
			</>
		);
	}

	return (
		<Modal show={isShow} onHide={hide} dialogClassName="modal-m modal-text modal-buy-insurance">
			<Modal.Header closeButton={true} closeLabel={""}>
				<h5 className="modal-title">{title}</h5>
			</Modal.Header>
			<div className="modal-body">{content}</div>
		</Modal>
	);
};
